// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import './App.css';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import PurchaseInvoices from './components/PurchaseInvoices';
import PurchaseCreate from './components/PurchaseCreate';

// تعریف ستون‌های پیش‌فرض (در سطح بالا)
const defaultColumns = [
  { id: 'invoiceNumber', label: 'شماره فاکتور', visible: true, order: 1 },
  { id: 'date', label: 'تاریخ', visible: true, order: 2 },
  { id: 'supplier', label: 'تامین‌کننده', visible: true, order: 3 },
  { id: 'totalAmount', label: 'مبلغ کل (تومان)', visible: true, order: 4 },
  { id: 'actions', label: 'عملیات', visible: true, order: 5 },
];

function MainApp() {
  const navigate = useNavigate();
  const location = useLocation();
  
  const [purchases, setPurchases] = useState(() => {
    const saved = localStorage.getItem('purchases');
    if (saved) {
      return JSON.parse(saved);
    }
    return [
      {
        id: 1,
        invoiceNumber: 'P-1001',
        date: '۱۴۰۲/۱۱/۱۰',
        supplier: 'تامین‌کننده ۱',
        totalAmount: 2500000,
        items: [
          { id: 1, product: 'محصول A', quantity: 5, unitPrice: 200000, total: 1000000 },
          { id: 2, product: 'محصول B', quantity: 3, unitPrice: 500000, total: 1500000 },
        ]
      },
      {
        id: 2,
        invoiceNumber: 'P-1002',
        date: '۱۴۰۲/۱۱/۰۹',
        supplier: 'توزیع‌کننده ۲',
        totalAmount: 1800000,
        items: [
          { id: 1, product: 'محصول C', quantity: 2, unitPrice: 900000, total: 1800000 },
        ]
      },
      {
        id: 3,
        invoiceNumber: 'P-1003',
        date: '۱۴۰۲/۱۱/۰۸',
        supplier: 'عمده‌فروش ۳',
        totalAmount: 750000,
        items: [
          { id: 1, product: 'محصول D', quantity: 1, unitPrice: 750000, total: 750000 },
        ]
      }
    ];
  });

  // ✅ state برای مدیریت ستون‌ها با ذخیره در localStorage
  const [columns, setColumns] = useState(() => {
    const savedColumns = localStorage.getItem('purchaseColumns');
    return savedColumns ? JSON.parse(savedColumns) : defaultColumns;
  });

  // ✅ ذخیره ستون‌ها در localStorage هر بار که تغییر می‌کنند
  useEffect(() => {
    localStorage.setItem('purchaseColumns', JSON.stringify(columns));
  }, [columns]);

  // ✅ ذخیره خریدها در localStorage
  useEffect(() => {
    localStorage.setItem('purchases', JSON.stringify(purchases));
  }, [purchases]);

  const addPurchase = (newPurchase) => {
    const newId = purchases.length > 0 ? Math.max(...purchases.map(p => p.id)) + 1 : 1;
    setPurchases([...purchases, { ...newPurchase, id: newId }]);
  };

  const deletePurchase = (id) => {
    setPurchases(purchases.filter(p => p.id !== id));
  };

  const updatePurchase = (id, updatedPurchase) => {
    setPurchases(purchases.map(p => p.id === id ? updatedPurchase : p));
  };

  const getPageTitle = () => {
    switch (location.pathname) {
      case '/':
        return 'داشبورد';
      case '/purchase-list':
        return 'لیست فاکتورهای خرید';
      case '/purchase-create':
        return 'ثبت فاکتور جدید';
      default:
        return 'داشبورد';
    }
  };

  const setCurrentPage = (path) => {
    if (path && typeof path === 'string') {
      navigate(path);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="app">
      <Sidebar setCurrentPage={setCurrentPage} currentPage={location.pathname} />
      <div className="main-content">
        <Header title={getPageTitle()} />
        <div className="page-content">
          <Routes>
            <Route path="/" element={<Dashboard purchases={purchases} />} />
            <Route path="/sales-list" element={<div>صفحه لیست فروش</div>} />
            <Route path="/sales-create" element={<div>صفحه ثبت فروش</div>} />
            <Route path="/sales-return" element={<div>صفحه برگشتی‌ها</div>} />
            <Route path="/daily-report" element={<div>گزارش روزانه</div>} />
            <Route path="/monthly-report" element={<div>گزارش ماهانه</div>} />
            <Route path="/profit-loss" element={<div>گزارش سود و زیان</div>} />
            <Route path="/purchase-list" element={
              <PurchaseInvoices 
                invoices={purchases}
                onDelete={deletePurchase}
                onUpdate={updatePurchase}
                columns={columns}
                setColumns={setColumns}
              />
            } />
            <Route path="/purchase-create" element={
              <PurchaseCreate onAddPurchase={addPurchase} setCurrentPage={setCurrentPage} />
            } />
          </Routes>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <MainApp />
    </BrowserRouter>
  );
}

export default App;